<div class="validity-banner" *ngIf="validityCheckInfo">
  <mat-icon>warning</mat-icon>
  <p>
    <span>IP: {{validityCheckInfo?.ip}}, </span>
    <span>Country: {{validityCheckInfo?.country_name}}, </span>
    <span>ISP: {{validityCheckInfo?.isp}}<ng-container *ngIf="validityCheckInfo.invalid_reason">, </ng-container></span> 
    <span>Reason: {{validityCheckInfo.invalid_reason}}</span>
  </p>
</div>
<app-loader></app-loader>
<mat-sidenav-container class="container">
  <mat-sidenav [alignedAt]="960" #endPoint [mode]="'side'" [opened]="openStatus" class="side-nav">
    <perfect-scrollbar [disabled]="!openStatus">
      <app-navigation></app-navigation>
    </perfect-scrollbar>
  </mat-sidenav>

  <mat-sidenav-content>
    <!-- <perfect-scrollbar> -->
    <app-toolbar (toggleSidbar)='endPoint.toggle()'></app-toolbar>
    <!-- <div class="unverified-bar" *ngIf="(!isPhoneVerified || !isWhatsAppVerified) && !isSubUser">
      <div class="bar-info">
        <p class="bar-message">Your {{ !isPhoneVerified ? 'phone number' : '' }} {{ (!isPhoneVerified && !isWhatsAppVerified) ? 'and' : '' }} {{ !isWhatsAppVerified ? 'WhatsApp number' : '' }} {{ (!isPhoneVerified && !isWhatsAppVerified) ? 'are' : 'is' }} not verified</p>
        <mat-icon matTooltip="Unverified accounts may face issues or be suspended. Please click on the 'Verify' button below to complete the process.">info</mat-icon>
      </div>
      <div class="bar-buttons">
        <button mat-flat-button color="primary" (click)="openDialog(checkPhoneDialog)">Verify</button>
        <button mat-button *ngIf="isPhoneVerified" color="primary" (click)="dismissVerify()">Dismiss</button>
      </div>
    </div> -->
    <div class="side-nav-container">
      <div class="layout-container">
        <div class="page-layout-top-bg" [class.new-shop-bg]="isShopNewVersion" *ngIf="!isPrint()"></div>
        <div class="center">
          <router-outlet></router-outlet>
        </div>
      </div>
      <br />
      <div class="policy-bar">
        <div class="links">
          <div class="link">
            <a href="/terms" target="_blank">Terms and Conditions</a>
          </div>
          <div class="link">
            | <a href="/privacy" target="_blank">Privacy policy</a>
          </div>
          <div class="link">
            | <a href="/refunds" target="_blank">Refund and cancellation policy</a>
          </div>
          <div class="link">
            | <a href="/shipping" target="_blank">Purchase and shipping policy</a>
          </div>
          <div class="link" style="padding: 0px">
            <img src="/assets/images/visa_master.png" class="footer-icon" />
          </div>
          <div class="link" style="padding: 0px">
            <img src="/assets/images/21972-312_SOC_NonCPA.png" class="footer-icon soc-icon" />
          </div>
          <div class="link" style="padding: 0px">
            <img src="/assets/images/21972-312_SOC_NonCPA_Blk.png" class="footer-icon soc-icon" />
          </div>
        </div>
        <div>
          <small>* General Merchant Disclaimer - The merchants represented are not sponsors of the rewards or otherwise affiliated with this company. The logos and other identifying marks attached are trademarks of and owned by each represented company and/or its affiliates. Please visit each company's website for additional terms and conditions.</small>
        </div>
        <!-- <div class="close">
          <a (click)="showTerms = false">
            <mat-icon>close</mat-icon>
          </a>
        </div> -->
      </div>
    </div>
    <!-- </perfect-scrollbar> -->

  </mat-sidenav-content>
</mat-sidenav-container>



<ng-template #checkPhoneDialog>
  <div>
      <h3 class="sub-heading">Verify {{ isWhatsAppNumber ? 'WhatsApp' : 'Phone' }} number</h3>
      <p *ngIf="selectedPhoneNumber">A verification code will be sent to {{ selectedPhoneNumber }}. Click on send or open profile to update it.</p>
      <p *ngIf="!selectedPhoneNumber">No {{ isWhatsAppNumber ? 'WhatsApp' : 'Phone' }} number found. Click on profile to update it.</p>
      <br />
      <button mat-button color="primary" [routerLink]="['/dashboard', 'profile']" (click)="closeAllDialogs()" class="inline-item">Edit profile</button>
      <button mat-raised-button color="primary" [disabled]="!selectedPhoneNumber" (click)="verifyPhone()">Send</button>
  </div>
</ng-template>

<ng-template #verifyPhoneDialog>
  <div>
    <form [formGroup]="verifyPhoneForm" (ngSubmit)="verifyPhoneCode()">
      <h3 class="sub-heading">Verify {{ isWhatsAppNumber ? 'WhatsApp' : 'phone' }} number</h3>
      <mat-form-field appearance="outline">
        <input matInput placeholder="Enter your code" formControlName="code" />
      </mat-form-field>
      <br />
      <button mat-raised-button color="primary" [disabled]="verifyPhoneForm.invalid">Verify</button>
    </form>
  </div>
</ng-template>

<ng-template #acceptInvitationDialog let-data>
  <div>
    <h3 class="sub-heading">
      You have been invited to join {{data.company}}.
    </h3>
    <p>Click accept to become a {{ data.company }} user.</p>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">Accept</button>
    <button mat-button color="primary" mat-dialog-close>Reject</button>
  </div>
</ng-template>